(function () {
  function initProduct() {
    var section = document.querySelector('[data-usa-product-section]');
    var productJson = document.querySelector('[data-usa-product-json]');
    if (!section || !productJson) return;
    var product;
    try { product = JSON.parse(productJson.textContent); } catch (e) { return; }
    var selected = (product.selected_or_first_available_variant || product.variants[0]).options.slice();
    var price = section.querySelector('[data-usa-price]');
    var addPrice = section.querySelector('[data-usa-add-price]');
    var variantInput = section.querySelector('[data-usa-variant-input]');
    var addButton = section.querySelector('[data-usa-add-to-bag]');

    function updateVariant() {
      var variant = product.variants.filter(function (item) {
        return item.options.every(function (value, index) { return selected[index] === value; });
      })[0];
      if (!variant) { if (addButton) { addButton.disabled = true; addButton.textContent = 'Unavailable'; } return; }
      if (variantInput) variantInput.value = variant.id;
      var formatted = (variant.price / 100).toLocaleString('en-US', {style: 'currency', currency: product.currency || 'USD'});
      if (price) price.textContent = formatted;
      if (addPrice) addPrice.textContent = formatted;
      if (addButton) {
        addButton.disabled = !variant.available;
        addButton.textContent = variant.available ? 'Add to bag · ' + formatted : 'Sold out';
      }
    }

    section.querySelectorAll('[data-usa-option-index]').forEach(function (button) {
      button.addEventListener('click', function () {
        var index = Number(button.getAttribute('data-usa-option-index'));
        var value = button.getAttribute('data-usa-option-value');
        selected[index] = value;
        section.querySelectorAll('[data-usa-option-index="' + index + '"]').forEach(function (item) { item.classList.remove('is-selected'); });
        button.classList.add('is-selected');
        var label = section.querySelector('[data-usa-option-label="' + index + '"]');
        if (label) label.textContent = value;
        updateVariant();
      });
    });

    section.querySelectorAll('[data-usa-gallery-image]').forEach(function (button) {
      button.addEventListener('click', function () {
        var main = section.querySelector('[data-usa-gallery-main]');
        if (!main) return;
        main.src = button.getAttribute('data-usa-gallery-image');
        main.alt = button.getAttribute('data-usa-gallery-alt') || product.title;
        section.querySelectorAll('[data-usa-gallery-image]').forEach(function (item) { item.classList.remove('usa-gallery__tile--active'); });
        button.classList.add('usa-gallery__tile--active');
      });
    });

    var modal = section.querySelector('[data-usa-size-modal]');
    function openModal() { if (modal) { modal.hidden = false; document.body.classList.add('usa-modal-open'); } }
    function closeModal() { if (modal) { modal.hidden = true; document.body.classList.remove('usa-modal-open'); } }
    section.querySelectorAll('[data-usa-open-size-chart]').forEach(function (button) { button.addEventListener('click', openModal); });
    section.querySelectorAll('[data-usa-close-size-chart]').forEach(function (button) { button.addEventListener('click', closeModal); });
    if (modal) {
      modal.addEventListener('click', function (event) { if (event.target === modal) closeModal(); });
      modal.querySelectorAll('[data-usa-chart-tab]').forEach(function (button) {
        button.addEventListener('click', function () {
          var target = button.getAttribute('data-usa-chart-tab');
          modal.querySelectorAll('[data-usa-chart-tab]').forEach(function (item) { item.classList.remove('is-active'); });
          modal.querySelectorAll('[data-usa-chart-panel]').forEach(function (panel) { panel.hidden = panel.getAttribute('data-usa-chart-panel') !== target; });
          button.classList.add('is-active');
        });
      });
    }
  }

  function initCollection() {
    var sort = document.querySelector('[data-usa-collection-sort]');
    if (!sort) return;
    sort.addEventListener('change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', sort.value);
      window.location.href = url.toString();
    });
  }

  function initNavigation() {
    document.querySelectorAll('.usa-mega-menu').forEach(function (menu) {
      menu.addEventListener('toggle', function () {
        if (!menu.open) return;
        document.querySelectorAll('.usa-mega-menu').forEach(function (other) { if (other !== menu) other.removeAttribute('open'); });
      });
    });
    document.querySelectorAll('.usa-mobile-drawer').forEach(function (drawer) {
      drawer.addEventListener('toggle', function () {
        document.body.classList.toggle('usa-mobile-drawer-open', drawer.open);
      });
      drawer.querySelectorAll('a').forEach(function (link) {
        link.addEventListener('click', function () { drawer.removeAttribute('open'); });
      });
    });
  }

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') {
      document.querySelectorAll('[data-usa-size-modal]').forEach(function (modal) { modal.hidden = true; document.body.classList.remove('usa-modal-open'); });
      document.querySelectorAll('.usa-mobile-drawer').forEach(function (drawer) { drawer.removeAttribute('open'); });
    }
  });
  document.addEventListener('DOMContentLoaded', function () { initProduct(); initCollection(); initNavigation(); });
}());

/* Open Shopify's native cookie preferences modal when the customer privacy banner is enabled. */
document.addEventListener('click', function (event) {
  var trigger = event.target.closest('[data-usa-cookie-preferences]');
  if (!trigger) return;
  if (window.privacyBanner && typeof window.privacyBanner.showPreferences === 'function') {
    event.preventDefault();
    window.privacyBanner.showPreferences();
  }
});
